import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import Badge from './Badge';

function pickTopCategory(categories = []) {
  // Prefer the 7 main categories if present
  const topNames = new Set([
    'Afdichten',
    'Verbinden',
    'Reinigen',
    'Handen',
    'Beschermen',
    'Smeren',
    'Gereedschappen',
  ]);

  const hit = categories.find((c) => topNames.has(c?.name));
  return hit || categories[0] || null;
}

export default function ProductCard({ product }) {
  const cat = pickTopCategory(product?.categories || []);

  return (
    <Card className="productCard" as="article">
      <Link to={`/products/${product.id}`} className="productCard__media" aria-label={product.name}>
        <img
          className="productCard__img"
          src={product.image || '/placeholder.svg'}
          alt={product.name}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = '/placeholder.svg';
          }}
        />
      </Link>
      <div className="productCard__body">
        <div className="productCard__meta">
          {cat && <Badge tone="brand">{cat.name}</Badge>}
          {product?.tech && <Badge>{product.tech.split('|')[0].trim()}</Badge>}
        </div>

        <h3 className="productCard__title">
          <Link to={`/products/${product.id}`} className="productCard__titleLink">
            {product.name}
          </Link>
        </h3>

        {product?.description ? <p className="productCard__desc">{product.description}</p> : null}

        <div className="productCard__actions">
          <Link to={`/products/${product.id}`} className="link">Bekijk details</Link>
          {product?.permalink ? (
            <a className="link" href={product.permalink} target="_blank" rel="noreferrer">
              Open op premtech.nl
            </a>
          ) : null}
        </div>
      </div>
    </Card>
  );
}
